import { isString } from '@sgme/fp';
import { CostAndCharge } from 'models/streaming/costsAndCharges';
import { GreeksTable } from 'state/quotes/details/details.model';

export interface SolvingParameters extends Record<string, Amount[]> {}
export interface RemainingValues extends Readonly<Record<string, Readonly<Amount | unknown>>> {}
export function isAmount(val: unknown): val is Amount {
  const castedVal = val as Amount;
  return isString(castedVal?.unit) && typeof castedVal.value === 'number';
}
export interface Underlying {
  code: string;
  referencePrice: number;
}
export interface Amount {
  value: number;
  unit: string;
}
export type PriceStreamingEvent = QuotePriceEvent<string> | CloseEvent | RejectedEvent | NextTradeAuthEvent;
export interface QuotePriceEvent<TRemaining> {
  type: 'NextQuotePrice';
  quoteId: string;
  greeks?: GreeksTable;
  costsAndCharge?: CostAndCharge[];
  quoteSequenceId: number;
  underlying?: Underlying;
  fxRate?: Underlying;
  solvingParameters: SolvingParameters;
  remainingValues: TRemaining;
}
export interface CloseEvent {
  type: 'CloseQuotePrice';
  quoteId: string;
}

export interface RejectedEvent {
  type: 'RejectedQuotePrice';
  quoteId: string;
  error?: string;
}
export interface NextTradeAuthEvent {
  type: 'NexTradeAuth';
  quoteId: string;
}
